
import Konva from 'konva';
import { RoofShape } from "./RoofShape";
import { SC_Input } from "../input/SC_Input";
import { Global } from "../utilities/global";
import { getCanvasStage, getCanvasLayer } from "../konva/getCanvas";
import { ScaleAdjustmentValue } from "../getScaleFactor";

export class SC_Beam {
	static UNKNOWN: number = 0;
	//Sparren
	static RAFTER: number = 1;
	//Pfetten
	static PURLIN: number = 2;
	static iBeamType: number = 1;

	static layerBeam: Konva.Layer = getCanvasLayer();
	static colorCode: string = "#000000";

	static drawBeam(l: any): void {
		if (l) {
			this.layerBeam = l;
		}
		this.layerBeam.removeChildren();
		var i: number;
		var nHeight: number = RoofShape.getCurrentRoofHeight();
		var nWidth: number = RoofShape.getCurrentRoofWidth();
		var nAbstand: number;
		var nCurX: number;
		var nCurY: number;
		if (SC_Input.iBeamType == SC_Beam.PURLIN) {
			nAbstand = SC_Input.nBeamDist;
			nCurY = nHeight - SC_Input.nBeamDist1;
			i = SC_Input.iBeamAmount;
			while (i--) {
				this.drawLine(0, nCurY, nWidth, nCurY);
				nCurY -= nAbstand;
			}
		} else if (SC_Input.iBeamType == SC_Beam.RAFTER) {
			nAbstand = SC_Input.nBeamDist;
			nCurX = SC_Input.nBeamDist1;
			i = SC_Input.iBeamAmount;
			while (i--) {
				this.drawLine(nCurX, 0, nCurX, nHeight);
				nCurX += nAbstand;
			}
		}
	}

	static drawLine(x1: number, y1: number, x2: number, y2: number) {
		var line = new Konva.Line({
			points: [ScaleAdjustmentValue.getScaleAdjust(x1),
			ScaleAdjustmentValue.getScaleAdjust(y1),
			ScaleAdjustmentValue.getScaleAdjust(x2),
			ScaleAdjustmentValue.getScaleAdjust(y2)],
			stroke: this.colorCode,
			strokeWidth: 2,
		});
		this.layerBeam.add(line);
	}

	static getScaleX(x: number): number {
		return x * Global.canRoof.scaleX;
	}
	static getScaleY(x: number): number {
		return x * Global.canRoof.scaleY;
	}
}


